(function () {
  'use strict';

  function setHiddenValue(input, value, disableWhenEmpty) {
    if (!input) return;

    value = value || '';
    input.value = value;

    if (disableWhenEmpty) {
      input.disabled = value === '';
    }
  }

  function updateUrl(card, root) {
    if (!card || !root) return;
    if (String(root.dataset.updateUrl) !== 'true') return;
    if (!window.history || !window.history.replaceState) return;

    var url = card.dataset.variantUrl;
    if (!url) return;

    window.history.replaceState({ path: url }, '', url);
  }

  function getStickyDropdownOption(dropdown, variantId) {
    if (!dropdown || !variantId) return null;

    var option = null;

    dropdown.querySelectorAll('[data-ddsb-sticky-variant-option]').forEach(function (item) {
      if (!option && item.dataset.variantId === String(variantId)) {
        option = item;
      }
    });

    return option;
  }

  function setStickyDropdownOpen(dropdown, open) {
    if (!dropdown) return;

    dropdown.classList.toggle('is-open', open);

    var toggle = dropdown.querySelector('[data-ddsb-sticky-dropdown-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  function setStickyOption(dropdown, option) {
    if (!dropdown || !option || option.classList.contains('is-disabled')) return;

    var form = dropdown.closest('form');
    var variantInput = form ? form.querySelector('[data-ddsb-sticky-variant-input]') : null;
    var selectedText = dropdown.querySelector('[data-ddsb-sticky-selected-text]');
    var stickyWrapper = dropdown.closest('.wt-product__sticky-buy__wrapper') || dropdown.closest('sticky-buy-button');
    var stickyPriceFinal = stickyWrapper ? stickyWrapper.querySelector('[data-ddsb-sticky-price-final]') : null;
    var stickyPriceCompare = stickyWrapper ? stickyWrapper.querySelector('[data-ddsb-sticky-price-compare]') : null;

    if (variantInput) {
      variantInput.value = option.dataset.variantId || '';
    }

    if (selectedText) {
      selectedText.textContent = option.dataset.label || option.textContent.trim();
    }

    if (stickyPriceFinal && option.dataset.displayPrice) {
      stickyPriceFinal.textContent = option.dataset.displayPrice;
    }

    if (stickyPriceCompare) {
      var comparePrice = option.dataset.displayComparePrice || '';
      stickyPriceCompare.textContent = comparePrice;
      stickyPriceCompare.classList.toggle('hidden', comparePrice === '');
    }

    dropdown.querySelectorAll('[data-ddsb-sticky-variant-option]').forEach(function (item) {
      var selected = item === option;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    setHiddenValue(form ? form.querySelector('[data-ddsb-sticky-quantity]') : null, option.dataset.quantity || '1', false);
    setHiddenValue(form ? form.querySelector('[data-ddsb-sticky-selling-plan]') : null, option.dataset.sellingPlan || '', true);
  }

  function syncStickySelect(variantId) {
    if (!variantId) return;

    document.querySelectorAll('[data-ddsb-sticky-dropdown]').forEach(function (dropdown) {
      var option = getStickyDropdownOption(dropdown, variantId);
      setStickyOption(dropdown, option);
    });
  }

  function findBundleInputByVariantId(variantId) {
    var input = null;

    document.querySelectorAll('[data-ddsb-option-input]').forEach(function (item) {
      if (!input && item.value === String(variantId)) {
        input = item;
      }
    });

    return input;
  }

  function syncMainPrice(card) {
    if (!card) return;

    var price = card.dataset.displayPrice || '';
    var comparePrice = card.dataset.displayComparePrice || '';

    document.querySelectorAll('[data-ddsb-main-price-final], [data-ddsb-main-price-sale]').forEach(function (item) {
      if (price) {
        item.textContent = price;
      }
    });

    document.querySelectorAll('[data-ddsb-main-price-compare]').forEach(function (item) {
      item.textContent = comparePrice;
      item.classList.toggle('hidden', comparePrice === '');
    });

    document.querySelectorAll('[data-ddsb-main-price-compare]').forEach(function (item) {
      var priceRoot = item.closest('.price');
      if (priceRoot) {
        priceRoot.classList.toggle('price--on-sale', comparePrice !== '');
      }

      var saleRoot = item.closest('.price__sale');
      if (saleRoot) {
        saleRoot.classList.toggle('visible-main-product', comparePrice !== '');
      }
    });
  }

  function setFormLoading(form, loading) {
    if (!form) return;

    form.classList.toggle('is-ddsb-loading', loading);

    var button = form.querySelector('[type="submit"]');
    if (button) {
      var label = button.querySelector('[data-ddsb-button-label]') || button.querySelector('span');

      button.disabled = loading;
      button.classList.toggle('is-loading', loading);

      if (label) {
        if (!label.dataset.ddsbOriginalText) {
          label.dataset.ddsbOriginalText = label.textContent.trim() || 'Add to cart';
        }

        if (loading) {
          label.innerHTML = '<span class="ddsb-button-spinner" aria-hidden="true"></span><span>Adding...</span>';
        } else {
          label.textContent = label.dataset.ddsbOriginalText || 'Add to cart';
        }
      }
    }
  }

  function publishCartUpdate(cart, item) {
    var detail = {
      cart: cart || null,
      item: item || null,
      source: 'dd-subscription-bundle'
    };

    if (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate && typeof publish === 'function') {
      publish(PUB_SUB_EVENTS.cartUpdate, detail);
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { detail: detail }));
  }

  function openCartDrawerFallback(cart, item) {
    var detail = { cart: cart || null, item: item || null, source: 'dd-subscription-bundle' };
    var opener = document.querySelector('.wt-cart__trigger');

    if (opener && typeof opener.click === 'function') {
      opener.click();
      return;
    }

    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.toggleDrawerClasses === 'function' && !drawer.isOpen) {
      drawer.toggleDrawerClasses();
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:open', { detail: detail }));
    window.dispatchEvent(new CustomEvent('cart:open', { detail: detail }));
  }

  function triggerMiniCartOpen(cart, item) {
    var drawer = document.querySelector('cart-drawer');

    if (drawer && item && typeof drawer.renderContents === 'function' && item.sections) {
      drawer.renderContents(item);
      publishCartUpdate(cart, item);
      return;
    }

    publishCartUpdate(cart, item);
    openCartDrawerFallback(cart, item);
  }

  function addToCart(form) {
    if (form.classList.contains('is-ddsb-loading')) return Promise.resolve();

    var formData = new FormData(form);
    var cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append('sections', cartDrawer.getSectionsToRender().map(function (section) {
        return section.id;
      }));
      formData.append('sections_url', window.location.pathname);
    }

    setFormLoading(form, true);

    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (error) {
            throw error;
          });
        }

        return response.json();
      })
      .then(function (item) {
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          window.setTimeout(function () {
            triggerMiniCartOpen(null, item);
          }, 150);
          return null;
        }

        return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', {
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
      })
      .then(function (response) {
        if (!response) return null;
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;

        window.setTimeout(function () {
          triggerMiniCartOpen(cart, null);
        }, 150);
      })
      .catch(function (error) {
        console.error('DD bundle add to cart failed:', error);
        form.submit();
      })
      .finally(function () {
        setFormLoading(form, false);
      });
  }

  function selectCard(input, options) {
    if (!input) return;

    var root = input.closest('[data-ddsb-variant-selector]');
    var card = input.closest('[data-ddsb-option]');
    if (!root || !card) return;
    if (String(card.dataset.available) === 'false') return;

    var idInput = root.querySelector('[data-ddsb-variant-id]');
    var quantityInput = root.querySelector('[data-ddsb-quantity]');
    var sellingPlanInput = root.querySelector('[data-ddsb-selling-plan]');
    var submitButton = root.querySelector('[data-ddsb-submit]');
    var buttonLabel = root.querySelector('[data-ddsb-button-label]');
    var available = String(card.dataset.available) !== 'false';

    root.querySelectorAll('[data-ddsb-option]').forEach(function (item) {
      var selected = item === card;
      item.classList.toggle('is-selected', selected);

      if (item.dataset.cardBackground || item.dataset.cardSelectedBackground) {
        item.style.setProperty(
          'background',
          selected ? (item.dataset.cardSelectedBackground || '') : (item.dataset.cardBackground || ''),
          'important'
        );
      }
    });

    setHiddenValue(idInput, card.dataset.variantId, false);
    setHiddenValue(quantityInput, card.dataset.quantity || '1', false);
    setHiddenValue(sellingPlanInput, card.dataset.sellingPlan || '', true);
    syncMainPrice(card);

    if (submitButton) {
      submitButton.disabled = !available;
    }

    if (buttonLabel) {
      buttonLabel.textContent = root.dataset.buttonText;
    }

    updateUrl(card, root);

    if (!options || options.syncSticky !== false) {
      syncStickySelect(card.dataset.variantId);
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-ddsb-option-input]');
    if (!input) return;
    selectCard(input);
  });

  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-ddsb-option]');
    if (!card || card.classList.contains('is-disabled')) return;

    var input = card.querySelector('[data-ddsb-option-input]');
    if (!input || input.disabled) return;

    if (!input.checked) {
      input.checked = true;
      selectCard(input);
    }
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-ddsb-sticky-dropdown-toggle]');
    var option = event.target.closest('[data-ddsb-sticky-variant-option]');
    var dropdown = toggle ? toggle.closest('[data-ddsb-sticky-dropdown]') : option ? option.closest('[data-ddsb-sticky-dropdown]') : null;

    document.querySelectorAll('[data-ddsb-sticky-dropdown].is-open').forEach(function (item) {
      if (item !== dropdown) {
        setStickyDropdownOpen(item, false);
      }
    });

    if (toggle) {
      setStickyDropdownOpen(dropdown, !dropdown.classList.contains('is-open'));
      return;
    }

    if (!option || option.classList.contains('is-disabled')) return;

    setStickyOption(dropdown, option);
    setStickyDropdownOpen(dropdown, false);

    var input = findBundleInputByVariantId(option.dataset.variantId);

    if (input && !input.disabled) {
      input.checked = true;
      selectCard(input, { syncSticky: false });
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-ddsb-sticky-dropdown]')) return;

    document.querySelectorAll('[data-ddsb-sticky-dropdown].is-open').forEach(function (dropdown) {
      setStickyDropdownOpen(dropdown, false);
    });
  });

  document.addEventListener('keydown', function (event) {
    var option = event.target.closest('[data-ddsb-sticky-variant-option]');
    var toggle = event.target.closest('[data-ddsb-sticky-dropdown-toggle]');

    if (event.key === 'Escape') {
      document.querySelectorAll('[data-ddsb-sticky-dropdown].is-open').forEach(function (dropdown) {
        setStickyDropdownOpen(dropdown, false);
      });
      return;
    }

    if (toggle && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      toggle.click();
      return;
    }

    if (option && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      option.click();
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form || (!form.classList.contains('ddsb-v__form') && !form.classList.contains('wt-product__sticky-buy__form'))) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    addToCart(form);
  }, true);
})();
